import React  from 'react';
import { Link } from 'react-router-dom';
import Tooltip from '@material-ui/core/Tooltip';
import { css, StyleSheet } from 'aphrodite';

import { ApiHelper } from '../../common/helpers/ApiHelper';
import { BaseEntityPage } from '../../common/components/BaseEntityPage';
import { AppStyles } from '../../styles/AppTheme';
import { Helper } from '../helpers/Helper';
import { UiHelper } from '../helpers/UiHelper';
import { AppConfig } from '../../AppConfig';
import { CustomProductsStyles } from '../../styles/CustomStyles';

const queryString = require('query-string');

export class OrgTeams extends BaseEntityPage {

  constructor(props) {
    super(props)
    this.query = queryString.parse(props.location.search);
    this.orgId = this.props.match.params.orgId
    this.pageTitle = Helper.getString('teams')
    this.breadCrumbs = [
      { title: Helper.getString('home'), to: this.baseRoute() },
      { title: this.pageTitle },
    ]
    this.toFetch = [
      { method: 'GET', endPoint: ApiHelper.makeUrlPath(['orgs'], { parentOrgId: this.orgId, pb: 'fieldDefSubOrg' }) },
      { method: 'GET', endPoint: ApiHelper.makeUrlPath(['orgs', this.orgId]) },
    ]
    this.tableHeadersMap = {
      Index: (current) => { return <span className={css(Styles.valueText)}>{current.__index + 1}</span> },
      Info: (current) => {
        return UiHelper.itemTitleId(current)
      },
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.apiData = {
      parentOrgId: this.orgId
    }
    this.pageKey = 'OrgTeams'
  }

  onFetchSuccess(results) {
    this.formDefinition = results[0].fieldDefSubOrg
    this.pageTitle = results[1].title
    this.setState({
      items: results[0].items.sort(
        function(a, b) { return a.title.toLowerCase() >= b.title.toLowerCase() ? 1 : -1 }),
    })
  }

  onTableValue(current, index) {
    switch (index) {
    case 0:
      return current.id
    case 1:
      return current.title
    default:
      return ''
    }
  }

  onAdd() {
    this.setState({
      apiMethod: 'POST',
      apiEndPoint: ApiHelper.makeUrlPath(['orgs']),
    });
  }

  onEdit(current) {
    this.setState({
      apiMethod: 'PUT',
      apiEndPoint: ApiHelper.makeUrlPath(['orgs', current.id]),
    });
  }

  onActions(current) {
    const actions = []
    if (!current.parentOrgId) {
      return actions
    }
    actions.push(UiHelper.buttonEdit(this, current))
    actions.push(
      <Link to={this.baseRoute() + '/suborgs/' + current.id + '/users'} key={current.id + '-users'}>
        <Tooltip title='Members' placement='top-start'>
          <span className={css(AppStyles.entityTableLinkIcon)}>
            <i className='material-icons-outlined'>people</i>
          </span>
        </Tooltip>
      </Link>
    )
    return actions
  }

}

const Styles = AppConfig.CUSTOM_STYLE ? CustomProductsStyles : StyleSheet.create({
  spanValue: {
    fontSize: 16
  },
  spanValueSmall: {
    fontSize: 14
  }
})